import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const fetchOrdersByStatus = createAsyncThunk(
  "order/fetchOrdersByStatus",
  async (status, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/order/list`,
        { status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data.orders;
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch orders"
      );
    }
  }
);

export const updateOrderFunction = createAsyncThunk(
  "orders/updateOrderFunction",
  async (
    { status, order_id, cancel_reason, includeDevice },
    { rejectWithValue }
  ) => {
    try {
      const payload = {
        status,
        order_id,
        cancel_reason,
      };

      if (includeDevice) {
        payload.device = "web";
      }

      const response = await PrivateAxios.post(
        `/api/user/order/updateOrder`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed to update order"
      );
    }
  }
);

const orderUpdateSlice = createSlice({
  name: "orders",
  initialState: {
    pending: [],
    progress: [],
    finished: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrdersByStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrdersByStatus.fulfilled, (state, action) => {
        const { status, orders } = action.payload;
        state[status] = orders;
        state.loading = false;
      })
      .addCase(fetchOrdersByStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch orders";
      })

      .addCase(updateOrderFunction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOrderFunction.fulfilled, (state, action) => {
        const updatedOrder = action.payload;

        if (updatedOrder.status === "cancelled") {
          state.pending = state.pending.filter(
            (order) => order.id !== updatedOrder.id
          );
          state.finished.push(updatedOrder);
        } else if (updatedOrder.status === "in progress") {
          state.pending = state.pending.filter(
            (order) => order.id !== updatedOrder.id
          );
          state.progress.push(updatedOrder);
        } else if (updatedOrder.status === "finished") {
          state.progress = state.progress.filter(
            (order) => order.id !== updatedOrder.id
          );
          state.finished.push(updatedOrder);
        }

        state.loading = false;
      })
      .addCase(updateOrderFunction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to update order";
      });
  },
});

export default orderUpdateSlice.reducer;
